import { action, createRequestTypes } from './base';

export const payoutActionTypes = {
  GET_PO_PAYMENT: createRequestTypes('GET_PO_PAYMENT'),
  CREATE_PO_PAYMENT: createRequestTypes('CREATE_PO_PAYMENT'),
  CREATE_PAYOUT_FLOW: createRequestTypes('CREATE_PAYOUT_FLOW'),
  UPDATE_PAYOUT_FLOW: createRequestTypes('UPDATE_PAYOUT_FLOW'),
  CREATE_CONNECT_SESSION: createRequestTypes('CREATE_CONNECT_SESSION'),
  CREATE_PAYMENT_SESSION: createRequestTypes('CREATE_PAYMENT_SESSION'),
  SET_SESSION: createRequestTypes('SET_SESSION'),
  SET_PAYMENT_SESSION: createRequestTypes('SET_PAYMENT_SESSION'),
  PAYMENT_VERIFY: createRequestTypes('PAYMENT_VERIFY'),
  GET_PENDING_PO_PAYMENT: createRequestTypes('GET_PENDING_PO_PAYMENT'),
};

/**
 * @param page
 * @param poId
 * @param getPoPaymentLoading
 * @param ccreatePoPaymentLoading
 * @param payload
 * @param callback
 * @param status
 * @param poPaymentId
 */
class PayoutActions {
    /**
     * @param {*} page
     * @param {*} poId
     * @param {*} poPaymentId
     * @param statusApproved
     * @param statusApprovedOnly
     * @param status
     * @return
     */
    getPoPayment = (page, poId, poPaymentId, status) => action(payoutActionTypes.GET_PO_PAYMENT.REQUEST, {
      page, poId, poPaymentId, status,
    })

    /**
     * @param {*} getPoPaymentLoading
     * @param poPaymentId
     * @return
     */
    getPoPaymentLoading = (getPoPaymentLoading, poPaymentId) => action(
      payoutActionTypes.GET_PO_PAYMENT.LOADING, {
        getPoPaymentLoading,
        poPaymentId,
      },
    )

    /**
     * @param {*} poPayment
     * @param poPaymentId
     * @return
     */
    getPoPaymentSuccess = (poPayment, poPaymentId) => action(payoutActionTypes.GET_PO_PAYMENT.SUCCESS, {
      poPayment,
      poPaymentId,
    })

    /**
     *
     * @param {*} payload
     * @param {*} callback
     * @return
     */
    createPoPayment = (payload, callback) => action(payoutActionTypes.CREATE_PO_PAYMENT.REQUEST, {
      payload,
      callback,
    })

    /**
     *
     * @param {*} createPoPaymentLoading
     * @return
     */
    createPoPaymentLoading = (createPoPaymentLoading) => action(
      payoutActionTypes.CREATE_PO_PAYMENT.LOADING, {
        createPoPaymentLoading,
      },
    )

    /**
     *
     * @param {*} payload
     * @param {*} callback
     * @return
     */
    createPaymentFlow = (payload, callback) => action(
      payoutActionTypes.CREATE_PAYOUT_FLOW.REQUEST, {
        payload,
        callback,
      },
    )

    /**
     * @param createPaymentFlowLoading
     * @return
     */
    createPaymentFlowLoading = (createPaymentFlowLoading) => action(
      payoutActionTypes.CREATE_PAYOUT_FLOW.LOADING, {
        createPaymentFlowLoading,
      },
    )

    /**
     *
     * @param {*} payload
     * @param {*} callback
     * @return
     */
    updatePaymentFlow = (payload, callback) => action(
      payoutActionTypes.UPDATE_PAYOUT_FLOW.REQUEST, {
        payload,
        callback,
      },
    )

    /**
     * @param updatePaymentFlowLoading
     * @param {*} createPoPaymentLoading
     * @return
     */
     updatePaymentFlowLoading = (updatePaymentFlowLoading) => action(
       payoutActionTypes.UPDATE_PAYOUT_FLOW.LOADING, {
         updatePaymentFlowLoading,
       },
     )

     /**
      *
      * @param {*} payload
      * @param {*} callback
      * @return
      */
     createConnectSession = (payload, callback) => action(
       payoutActionTypes.CREATE_CONNECT_SESSION.REQUEST, {
         payload,
         callback,
       },
     )

     /**
      * @param createConnectSessionLoading
      * @return
      */
     createConnectSessionLoading = (createConnectSessionLoading) => action(
       payoutActionTypes.CREATE_CONNECT_SESSION.LOADING, {
         createConnectSessionLoading,
       },
     )

     /**
      *
      * @param {*} payoutSession
      * @return
      */
     createConnectSessionSuccess = (payoutSession) => action(
       payoutActionTypes.CREATE_CONNECT_SESSION.SUCCESS, {
         payoutSession,
       },
     )

     /**
      *
      * @param {*} payload
      * @param {*} callback
      * @return
      */
     verifyPayment = (payload, callback) => action(
       payoutActionTypes.PAYMENT_VERIFY.REQUEST, {
         payload,
         callback,
       },
     )

     /**
      * @param verifyPaymentLoading
      * @return
      */
     verifyPaymentLoading = (verifyPaymentLoading) => action(
       payoutActionTypes.PAYMENT_VERIFY.LOADING, {
         verifyPaymentLoading,
       },
     )

     /**
      * @param verifyPayment
      * @return
      */
     verifyPaymentSuccess = (verifyPayment) => action(
       payoutActionTypes.PAYMENT_VERIFY.SUCCESS, {
         verifyPayment,
       },
     )

     /**
      *
      * @param {*} payload
      * @param {*} callback
      * @return
      */
     createPaymentSession = (payload, callback) => action(
       payoutActionTypes.CREATE_PAYMENT_SESSION.REQUEST, {
         payload,
         callback,
       },
     )

     /**
      * @param createPaymentSessionLoading
      * @param createConnectSessionLoading
      * @return
      */
     createPaymentSessionLoading = (createPaymentSessionLoading) => action(
       payoutActionTypes.CREATE_PAYMENT_SESSION.LOADING, {
         createPaymentSessionLoading,
       },
     )

     /**
      * @param payoutSessionPayment
      * @param {*} payoutSession
      * @return
      */
     createConnectSessionSuccess = (payoutSessionPayment) => action(
       payoutActionTypes.CREATE_PAYMENT_SESSION.SUCCESS, {
         payoutSessionPayment,
       },
     )

     /**
      *
      * @param {*} payload
      * @param {*} callback
      * @return
      */
     setPaymentSession = (payload, callback) => action(
       payoutActionTypes.SET_PAYMENT_SESSION.REQUEST, {
         payload,
         callback,
       },
     )

     /**
      * @param createPaymentSessionLoading
      * @param setPaymentSessionLoading
      * @param createConnectSessionLoading
      * @return
      */
     setPaymentSessionLoading = (setPaymentSessionLoading) => action(
       payoutActionTypes.SET_PAYMENT_SESSION.LOADING, {
         setPaymentSessionLoading,
       },
     )

     /**
      *
      * @param {*} payload
      * @param {*} callback
      * @return
      */
      connectSession = (payload, callback) => action(
        payoutActionTypes.SET_SESSION.REQUEST, {
          payload,
          callback,
        },
      )

      /**
       * @param connectSessionLoading
       * @param createConnectSessionLoading
       * @return
       */
       connectSessionLoading = (connectSessionLoading) => action(
         payoutActionTypes.SET_SESSION.LOADING, {
           connectSessionLoading,
         },
       )

       /**
        *
        * @return
        */
       getPendingPoPayment = () => action(payoutActionTypes.GET_PENDING_PO_PAYMENT.REQUEST, {
       })

       /**
        * @param {*} getPoPaymentLoading
        * @param getPendingPoPaymentLoading
        * @param poPaymentId
        * @return
        */
       getPendingPoPaymentLoading = (getPendingPoPaymentLoading) => action(
         payoutActionTypes.GET_PENDING_PO_PAYMENT.LOADING, {
           getPendingPoPaymentLoading,
         },
       )

       /**
        * @param {*} poPayment
        * @param pendingPoPayment
        * @param poPaymentId
        * @return
        */
       getPendingPoPaymentSuccess = (pendingPoPayment) => action(payoutActionTypes.GET_PENDING_PO_PAYMENT.SUCCESS, {
         pendingPoPayment,
       })
}

export default new PayoutActions();
